'use client';

import { classes } from '@/utils/classes/classes';
import { gameImageSrcSets } from '@/utils/images/attributes';
import BadgeFactoryClient from '@/app/components/badge/badge-factory.client';
import { SwjBorderOverlay } from '../game/subcomponents/swj-border-overlay/swj-border-overlay';
import { TextBadge } from '@/app/components/badge/layouts/text/text-badge';

import './styles/default.scss';

type GameBadgeImageProps = {
    logoUrl: string;
    backgroundUrl: string;
    customBackgroundColor: string;
    name: string;
    priority?: boolean;
    label?: string;
    feedsCode?: string;
    isSiteWideJackpot?: boolean;
};

type ImageProps = {
    url: string;
    className: string;
    alt: string;
    priority: boolean;
};

const GameImage = ({ url, className, alt, priority }: ImageProps) => (
    <img
        width={300}
        height={300}
        className={className}
        src={url}
        alt={alt}
        loading={priority ? 'eager' : 'lazy'}
        fetchPriority={priority ? 'high' : 'auto'}
        {...gameImageSrcSets(url)}
    />
);

export const GameBadgeImage = ({
    logoUrl,
    backgroundUrl,
    customBackgroundColor,
    name,
    priority = false,
    label,
    feedsCode,
    isSiteWideJackpot
}: GameBadgeImageProps) => {
    return (
        <div
            className={classes('game__image-container', priority && 'priority')}
            style={{ backgroundColor: customBackgroundColor }}>
            {label && (
                <BadgeFactoryClient feedsCode={feedsCode}>
                    <TextBadge label={label} />
                </BadgeFactoryClient>
            )}
            <SwjBorderOverlay isSiteWideJackpot={isSiteWideJackpot} swjLabel="default" />
            {/* TODO: add srcsets */}
            {logoUrl?.length > 0 && (
                <GameImage url={logoUrl} className="logo" alt={`game-${name}-logo`} priority={priority} />
            )}
            {backgroundUrl?.length > 0 && (
                <GameImage
                    url={backgroundUrl}
                    className="background"
                    alt={`game-${name}-background`}
                    priority={priority}
                />
            )}
        </div>
    );
};
